import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, consigneeValidations } from "./consignee-schema";
import ConsigneeInfo from "./components/ConsigneeInfo";
import { useLocation } from "react-router-dom";
import { editConsignee } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { getConsignee } from "services/data.internal.service";

function EditConsignee() {
  const location = useLocation();
  const { customerCode, consigneeCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  useQuery({
    queryKey: ["consignee", { customerCode, consigneeCode }],
    queryFn: () => getConsignee({ customerCode, consigneeCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editConsigneeMutation = useMutation(editConsignee, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(consigneeValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
  } = form;

  const infoProps = {
    mode: "EDIT",
    getValues,
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    editConsigneeMutation.mutate(data, { onSuccess: () => queryClient.invalidateQueries(["consignee"]) });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ConsigneeInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty} url="/setup/consignee" />
      </form>
    </Layout>
  );
}

export default EditConsignee;
